import ContentScroller from './ContentScroller';

export default ContentScroller;
